import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'orders';

type TData = Record<string, any>;
type TError = AxiosError;
type BodyType = {
  comment: string;
  status: string;
};

type TVariables = {
  orderId: number;
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useRevertOrderApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ orderId, body }: TVariables) => {
    try {
      const { data } = await http.patch(endpoint + `/${orderId}/revert`, body);

      toast({
        description: 'order have been reverted successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
